/**
 * sph-voxel-splat.wgsl — SPH parçacık → voxel kafes köprü shader'ı (Faz 0).
 * Her parçacık, bulunduğu voxel (+ komşuluk yarıçapı) için dolum zamanını
 * atomicMin ile damgalar. Sonuç: per-voxel ilk metal varış zamanı (ms) —
 * CA motorunun `dolumZamani` çıktısının GPU/SPH karşılığı.
 *
 * Kendine yeten binding düzeni (SPH ortak gruplarından bağımsız):
 *   @group(0) @binding(0) uniform SplatParams
 *   @group(0) @binding(1) read  positionMass (SPH parçacık buffer'ı)
 *   @group(0) @binding(2) read_write fillTime: array<atomic<u32>>  (0xFFFFFFFF = dolmadı)
 */
export const SPLAT_PARAMS_BOYUT = 48; // byte (16B hizalı 3 satır)

export const VOXEL_SPLAT_PASS = `
struct SplatParams {
  origin_x: f32,
  origin_y: f32,
  origin_z: f32,
  cellSize: f32,
  dim_x: u32,
  dim_y: u32,
  dim_z: u32,
  activeCount: u32,
  simTimeMs: u32,
  radiusVoxel: u32,
  _p0: u32,
  _p1: u32,
}

@group(0) @binding(0) var<uniform> sp: SplatParams;
@group(0) @binding(1) var<storage, read> positionMass: array<vec4<f32>>;
@group(0) @binding(2) var<storage, read_write> fillTime: array<atomic<u32>>;

@compute @workgroup_size(256)
fn voxelSplat(@builtin(global_invocation_id) gid: vec3<u32>) {
  let idx = gid.x;
  if (idx >= sp.activeCount) { return; }

  let pos = positionMass[idx].xyz;
  let rel = (pos - vec3<f32>(sp.origin_x, sp.origin_y, sp.origin_z)) / sp.cellSize;
  let cx = i32(floor(rel.x));
  let cy = i32(floor(rel.y));
  let cz = i32(floor(rel.z));

  let nx = i32(sp.dim_x);
  let ny = i32(sp.dim_y);
  let nz = i32(sp.dim_z);
  let r = i32(sp.radiusVoxel);

  for (var dz = -r; dz <= r; dz++) {
    let z = cz + dz;
    if (z < 0 || z >= nz) { continue; }
    for (var dy = -r; dy <= r; dy++) {
      let y = cy + dy;
      if (y < 0 || y >= ny) { continue; }
      for (var dx = -r; dx <= r; dx++) {
        let x = cx + dx;
        if (x < 0 || x >= nx) { continue; }
        let lin = u32(x) + sp.dim_x * (u32(y) + sp.dim_y * u32(z));
        atomicMin(&fillTime[lin], sp.simTimeMs);
      }
    }
  }
}
`;
